export enum ConfirmationType {
    InvitationToQuiz = "InvitationToQuiz",
    RegisterToSystem = "RegisterToSystem"
}